<template>
  <div class="goods">
    <!-- <div class="ProductDescription"> -->
      <!-- 轮播图上面的文字 -->
      <!-- <span>{{descs}}</span>
    </div> -->
    <!-- 轮播 -->
    <div class='Swiper'>
      <swipe
      :autoplayTime='3000'
        >
        <swipe-item  v-for="(item_head,index_head) in (goods.imgs||'').split(',')"
        :key="index_head">
          <img style="width:100%"  :src="item_head.indexOf('.gif') > -1 ? item_head : item_head + process" >
        </swipe-item>
        </swipe>
    </div>
    <div class="scroll-top">
        <div class="scroll" v-if="buyShow" v-show="textShow" >{{buy}}</div>
    </div>
    <!-- 商品价格 -->
    <div class="fontMoney">
      <p>{{$t('Pay.money')}}{{ formatPrice(goods.price) }}<span style="color: rgba(000, 000, 000,0.4); font-size: 14px; text-decoration: line-through;margin-left:5px">{{$t('Pay.money')}}{{ parseInt(formatPrice(goods.price)*1.4) }}</span></p>
    </div>
    <!-- 商品分组 -->
    <van-cell-group style="padding: 0 10px; border-top: 1px dashed #ccc; border-bottom: 1px dashed #ccc;">
         <div class="goods-methods">
          <div v-if="itemsIsShow" style=" display: flex;flex-wrap:wrap;">
            <span v-for="(item,index) in items " :key='index' @click="onNavBar(item.id)">{{item.title}}</span>
          </div>
        </div>
    </van-cell-group>
    <div>
        <!-- 商品名称 -->
        <!-- <div class="goods-brief"><span v-if="brief">{{goods.brief}}</span><p>{{goods.prodName}}</p></div> -->
        <div class="goods-brief"><p>{{goods.prodName}}</p></div>
    </div>
    <div style="max-with:750px">
        <!-- 粘性布局 -->
        <van-sticky  :offset-top="41">
            <!-- <div class="stickyDiv">
                <div @click="goTulist(1)"><span>{{$t('ensure.introduce')}}</span></div>
                <div @click="goTulist(2)"><span>{{$t('ensure.Specifications')}}</span></div>
                <div @click="goTulist(3)"><span>{{$t('ensure.ensure')}}</span></div>
            </div> -->
            <div class="stickyDiv">
                <div v-for="(item,index) in ensureList" :key="index" :class="{ stickyActive: item.value}" @click="goTulist(index)"><span>{{item.lable}}</span></div>
            </div>
        </van-sticky>
    </div>
    <!-- 富文本 商品详情 -->
    <div class="center">
      <!-- <div style="background: #CCC;border-top-right-radius: 7px;border-top-left-radius: 7px;">
      </div> -->
      <div class="content" :style="{width:'100%',}" v-html="letslazyload(goods.content)" v-lazy-container="{ selector: 'img' }"></div>
      <!-- <div class="switchs" v-if="$route.name=='Detail'">
        <span> 是否显示评论</span> <van-switch v-model="buyShow" size="20" active-color="red" />
      </div> -->
    </div>
    <!-- 商品规格图 -->
    <div class="attrContent" :style="{width:'100%',}" v-html="skuImgData.attrContent">

    </div>
    <!-- 商品保证图 -->
    <div class="ensureContent" :style="{width:'100%',}" v-html="skuImgData.ensureContent">

    </div>
    <!-- <div class="switchs" v-if="$route.name=='Detail'">
       <span> 是否显示评论</span> <van-switch v-model="buyShow" size="20" active-color="red" />
    </div>-->
    <!-- 评论块 -->
    <div  v-if="buyShow" class="buy-body">
        
        <!-- <div class="title-top van-row" style="font-size:16px;font-width:200;padding:20px 15px;padding-left:20px;">{{$t('comment.comment')}}</div>
        <div style="height:150px;margin-left:10px;">
          <div style="margin-left:20px">
            <van-radio-group v-model="radios" direction="horizontal">
              <van-radio name=0  checked-color="red">{{$t('comment.Praise')}}</van-radio>
              <van-radio name=1  checked-color="red">{{$t('comment.Average')}}</van-radio>
              <van-radio name=2  checked-color="red">{{$t('comment.Badreview')}}</van-radio>
            </van-radio-group>
          </div>
          
          <van-field
            v-model="message"
            rows="1"
            autosize
            type="textarea"
            :placeholder="$t('comment.PleaseEnteraComment')"
          />
        </div>
        <div style="margin-left:20px;">
          <van-uploader v-model="fileList" :max-count="3" multiple />
        </div>
        <div style="width:90%;margin:20px" v-show="onButtom">
            <van-button type="danger" style="background:#fc2a62 !important" size="large" @click="addProdCommList">{{$t('comment.submitcomments')}}</van-button>
        </div> -->
        

        <!-- <div class="title-top van-row" style="font-size:16px;font-width:200;padding:20px 15px;" v-if="prodCommList.length"><p>评论</p><p>查看全部</p></div> -->
        <!-- <div class="commentTitle"><p>评论</p><p>查看全部></p></div>
        <div v-for="(item,index) in prodCommList" :key="index" class="prod-comm">
          <van-card 
            :desc='item.recTime'
             :title="item.nickName||'匿名用户 '+index+1*10000"
            thumb="../../../static/123.jpg"
          >
          </van-card>
          <div>
              <div style="margin:10px 20px;">{{item.content}}</div>
              <div  class="img-flex">
                  <p  v-if="!item.pics" ></p>
                  <van-image v-else-if="item.pics.indexOf(',')!=-1" width="100" v-for="(items,indexs) in item.pics.split(',')" :key="indexs" :src='items' />
                  <van-image  v-else width="100" height="100" :src='item.pics' />
              </div>
          </div>
        </div> -->
      <div style="display:flex">
        <van-image-preview v-model="show" :images="images" @change="onChange">
          <template v-slot:index>第{{ index+1 }}张</template>
        </van-image-preview>
       </div>
      <van-row type="flex" justify="space-between" class="commentTitle" >
        <van-col span="9"><span>商品評價 共({{commentNums || 0}})則評論</span></van-col>
        <!-- <van-col span="5"><span @click="goToComment">查看全部 ></span></van-col> -->
        <van-col span="5">
             <span @click="goToComment">查看全部 ></span>
        </van-col>
      </van-row>
        <van-row style="margin:10px 0px;">
          <div v-for="(item,index) in prodCommList" :key="index" class="prod-comm" >
            <van-card 
              :desc='item.recTime'
              :title="item.nickName||'匿名用户 '+index+1*10000"
              thumb="../../../static/123.jpg"
            >
            </van-card>
          <div>
            <div style="margin:10px 20px;">{{item.content}}</div>
              <div  class="img-flex">
                <p  v-if="!item.pics" ></p>
                <van-image v-else-if="item.pics.indexOf(',')!=-1" width="100" v-for="(items,indexs) in item.pics.split(',')" :key="indexs" :src='items' @click="getimgList(item.pics,indexs)" />
                <van-image  v-else width="100" height="100" :src='item.pics' @click="getimgList(item.pics,0)" />
              </div>
            </div>
          </div>
        </van-row>
    </div> 
    <!-- 站点 -->
    <div class="sites">
        <span v-for="(item,index) in siteList" :key="index" @click="toDetail(item.id,item.region)">
          {{item.title}}
          <span v-show="index<(siteList.length-1)" >|</span>
        </span>
    </div>
    <!-- 底部选项卡块 -->
    <!-- <van-goods-action>
      <van-goods-action-icon icon="wap-home" @click="home">{{$t('indexdata.index')}}</van-goods-action-icon>
      <van-goods-action-icon
        icon="cart-o"
        @click="onClickCart"
        :info="count ==0?'':count"
      >{{$t('detail.cart')}}</van-goods-action-icon> -->
      <!-- 选择地址时加入购物车:info="carNmus" -->
      <!-- <van-goods-action-button type="warning" @click="addCarts">{{$t('detail.add_cart')}}</van-goods-action-button> -->
      <!-- 选择地址时立即购买 -->
      <!-- <van-goods-action-button type="danger" @click="alertSKU">{{$t('detail.buy_now')}}</van-goods-action-button> -->

    <!-- </van-goods-action> -->
    
    <div class="goods-action" v-if="!isButtonCar">
        <div class="goods-action-button">
            <div class="goods-action-button-item"  @click="goTologistics">
              <img src="@/assets/logistics.png" alt="" style="width:20px"><p>{{$t('order.query')}}</p>
            </div>
            <div class="goods-action-button-item"  @click="onClickCart">
              <img src="@/assets/balckCar.png" alt="" style="width:20px;height: 21.84;"><p>{{$t('detail.cart')}}</p>
            </div>
        </div>
        <div class="goods-action-tocar"  @click="addCarts">{{$t('detail.add_cart')}}</div>
        <div class="goods-action-ljgm" @click="alertSKU">{{$t('detail.buy_now')}}</div>
    </div>
    <div class="goods-action" v-else>
        <div class="JA_goods-action_item" >
            <div class="JAflex"  @click="goTologistics">
            <img src="@/assets/logistics.png" alt="" style="width:24px"><p >{{$t('order.query')}}</p>
          </div>
        </div>
        <div class="JA_goods-action-tocar"  @click="addCarts">{{$t('detail.add_cart')}}</div>
        <div class="JA_goods-action-ljgm" @click="alertSKU">{{$t('detail.buy_now')}}</div>
        <div class="JA_goods-action_item">
          <div class="JAflex"  @click="onClickCart">
              <img src="@/assets/balckCar.png" alt="" style="width:24px;height: 21.84;"><p >{{$t('detail.cart')}}</p>
            </div>
        </div>
    </div>
    <van-action-sheet v-model="cartShow" :title="$t('Product_details_page.Select_product_specification')" class="sheet">
         <van-row class="title">
           <div style="display: flex;">
             <img :src="skuImgData.pic" style="width:100px;height:100px">
              <!-- 商品套餐标题 + 卖点 -->
             <div class="name shopTitle"><span >{{skuImgData.prodName}}</span><p style="padding: 10px 0;color: red;">{{skuImgData.brief}}</p></div>
             <!-- <div class="name shopTitle"></div> -->
           </div>
          <div class="shopMoney">
            <span  >{{$t('Pay.money')}}{{ formatPrice(comboList.price) }}</span>
          </div>
        </van-row>
        <div class="cont" v-if="cartShow">
          <!-- 选择套餐 -->
          <van-row class="comboSelect" >
              <div class="name"><span>{{$t('Product_details_page.Package_selection')}}:</span></div>
              <van-row  class="list"> 
                  <van-tag class="selectCombo"
                    plain 
                    v-for="(itemc,indexc) in goods.comboParams" :key="indexc"
                    :type="comboList.index==indexc?'danger':'primary'"
                    :color="comboList.index==indexc?'': '#dcdfe6'" 
                    :text-color="comboList.index==indexc?'': '#94979c'"
                    @click="toSelectCombo(indexc,itemc.title,itemc.price,itemc.oriPrice)"
                    >
                      {{itemc.title}}
                  </van-tag>
              </van-row>
          </van-row>
          <div class="combo"
            v-for="(item,index) in selectComboList.comboProds" 
            :key="index"
          > 
          
          <!-- SKU图 -->
          <!-- {{item.productProps}} -->
            <!-- <van-row class="goodSheet" type="flex">
              <van-col style="width: 55%;">
                  <img  :src="pic[index] +  `?x-oss-process=image/resize,w_ ${ clientWidth < 700 ? 300 : clientWidth }`" style="height: 100px;width: 100px;">
              </van-col>
              <van-col class="skuName">
                  <div class="name">
                     <span>{{properties[index]}}
                    </span>
                  </div>
              </van-col>
            </van-row>
             <van-row style="width: 80%;margin: 0 5%;font-size: 16px;font-weight: 550;color: #736868">
              <div class="name"><span>{{item.prodName}}</span></div>
            </van-row> -->
            
            <div style="padding:2% 3% 0% 3%">
              <!-- <p style="">第{{index+1}}件產品</p> -->
              <p style="">{{$t('ensure.di')}}{{(index+1)}}{{$t('ensure.commodity')}}</p>
            </div>
            <van-row v-for="(itemp,indexp) in item.productProps" :key="indexp">
              <van-row style="width: 90%;margin: 0 5%;">
                <van-cell-group :border="false">
                  <van-cell :border="false">
                    <div class="sku_line_item">
                      <span style="flex:1">{{itemp.propName}}</span>
                    </div>
                  </van-cell>
                </van-cell-group>
                <!-- 选择SKU -->
                <!-- <van-tag 
                  v-for="(itemm,indexx) in itemp.prodPropValues" 
                  plain
                  :key="itemm.skuId" 
                  :type="selectSkuNList[index][indexp]==indexx?'danger':'primary'" 
                  :color="selectSkuNList[index][indexp]==indexx?'': '#dcdfe6'" 
                  :text-color="selectSkuNList[index][indexp]==indexx?'': '#94979c'"
                  class="tag"
                  @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)"
                >{{itemm.propValue}}</van-tag> -->
                <!-- <img  v-for="(itemm,indexx) in itemp.prodPropValues"  :key="itemm.skuId" style="width:100px;height:auto"   @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)" :src="itemm.imageUrl" alt=""> -->
                <div v-for="(itemm,indexx) in itemp.prodPropValues"  :key="itemm.skuId" style="display: inline-block;"> 
                  <van-tag
                    v-if="!itemm.imageUrl"
                    plain
                    :type="selectSkuNList[index][indexp]==indexx?'danger':'primary'" 
                    :color="selectSkuNList[index][indexp]==indexx?'': '#dcdfe6'" 
                    :text-color="selectSkuNList[index][indexp]==indexx?'': '#94979c'"
                    class="tag"
                    @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)"
                  >{{itemm.propValue}}</van-tag>
                  
                  <div v-else>
                    <van-tag 
                      style="width:100px;height: 100px;display: table;text-align: center;padding:0;overflow: hidden;border-radius: 5px;"
                      plain
                      :type="selectSkuNList[index][indexp]==indexx?'danger':'primary'" 
                      :color="selectSkuNList[index][indexp]==indexx?'': '#dcdfe6'" 
                      :text-color="selectSkuNList[index][indexp]==indexx?'': '#94979c'"
                      class="tag"
                      @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)"
                    >
                    <img  style="width:100px;height:100px"   @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)" :src="itemm.imageUrl + skuProcess " alt="">
                    </van-tag>
                    <p :style="{'color':selectSkuNList[index][indexp]==indexx?'red': ''}"  @click="toSelectSkuName(index,indexx,indexp,itemm.valueId,item,itemp,itemm)"  style="text-align: center;width:100px;display: flex;">{{itemm.propValue}}</p>
                  </div>
                </div>
              </van-row>
            </van-row>
          </div>
        </div>
         <van-goods-action style="z-index:99;position: sticky;display: flex;justify-content: center;">
          <!--加入购物车 -->
          <!-- <van-goods-action-button type="warning"   v-if="iscarfalse"  :disabled='flag' :text="$t('detail.add_cart')" @click="addToCar" /> -->
          <van-button  class="zdyButton"   v-if="iscarfalse"  :disabled='flag' :text="$t('detail.add_cart')" @click="addToCar">{{$t('detail.add_cart')}}</van-button>
          <router-link :to="'/orderStep4/' + country+'_' + prodId">
            <van-button  class="zdyButton"  v-if="ispurchase" :disabled='flag' :text="$t('Product_details_page.Buy_now')" @click="buyNow" >{{$t('Product_details_page.Buy_now')}}</van-button>
          </router-link>
          <!-- 立即购买 -->
          <!-- <van-goods-action-button type="danger"  v-if="ispurchase" :disabled='flag' :text="$t('Product_details_page.Buy_now')" @click="buyNow" /> -->
        </van-goods-action>
    </van-action-sheet>
  </div>
</template>

<script>
import {
  Rate,
  Image as VanImage,
  Card,
  Button,
  DropdownMenu,
  DropdownItem,
  Field,
  Swipe,
  SwipeItem,
  Toast,
  Sku,
  Grid,
  GridItem,
  Tag,
  Image,
  Lazyload,
  Stepper,
  ActionSheet,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  NavBar,
  Col,
  Row,
  ImagePreview,
} from "vant";
import { mapMutations, mapState } from "vuex";
import home from "@/api/home";
import { findIndex, remove, cloneDeep } from "lodash";
import goods from "@/api/goods";
import { getQueryVariable, compare } from "@/utils/index";
import { roc_711 } from "../../../../static/roc_711";
import { roc_qj } from "../../../../static/roc_qj";
import { roc_tw } from "../../../../static/roc_tw - OK";
import { roc_tw_new } from "../../../../static/roc_tw - newOK";
import { moneys } from "../../../../static/moneyString";
import { Url } from "@/utils/const";
import googFb from '../../../google/google'
// import language from './index/common/Language';
export default {
  // components: {language},
  name:'GoodsCategoryDetail',
  data() {
    return {
      isstickyActive:false,
      isButtonCar:false,
      process:'',
      isActive:false,
      arrayProdName:[],
      prodCommentList:[
        {
            pic:'https://s-cf-tw.shopeesz.com/file/2958a7592a2a9cb3d97e864177289d18_tn',
            prodName:'山葉 YAMAHA 原廠齒輪油 G-110.GII-110.G-130.GII-130.GII-200 勁戰.force',
            prodNorms:'Variation: GII-130  藍罐 10W-30',
            businessName:"Seller's Response",
            businessReply:'感謝您的購買，若有需要歡迎隨時回購，期待下次為您服務🙏🙏'
        }
      ],
      show: false,
      index: 0,
      images: [],
      iscarfalse:false,
      ispurchase:false,
      numss:0,
      nums:0,
      num: 0,
      isBtndisable: false,
      isIndonesia: false,
      issubmit: false,
      iscountText: false,
      countText: "Kembalilah dalam beberapa detik",
      countss: "kode verifikasi",
      orderItemNums: 1,
      ProdListName: [],
      priceTitle: "",
      combofareText: "",
      brief: true,
      index: 0,
      onButtom: true,
      oneShow: false, // 如果是宅配的 那么隐藏掉第一级的联动
      Request: true, //防抖
      isPage: null,
      fbnum: 0,
      maxlength: "20",
      // textData:'',
      textShow: false,
      radios: "0",
      fileList: [], //上传的图片
      message: "", //评论内容
      prodCommListImg: [],
      prodCommList: [],
      buyShow: false,
      buy: "",
      itemsIsShow: true,
      countList: [],
      moneysString: "",
      disableds: true,
      postCodeShow: false,
      getValue: 1,
      areaCode: "",
      area1: -1,
      area1Data: [],
      area2: -1,
      area2Data: [],
      area3: -1,
      area3Data: [],
      area4: -1,
      area4Data: [],
      area5: -1,
      area5Show: false,
      area5Data: [],
      area4Show: false, // 第四级联动
      pid: "",
      address: {},
      userData: {
        name: "",
        phones: "",
        address: "",
        detailed: "",
        eMail: "",
        stay: "",
        postCode: "",
      },
      errorInfo: {
        nameValue: false,
        emailValue: false,
        phoneValue: false,
        arrNameValue: false,
        arrPhoneValue: false,
      },
      radioSelected: 1,
      radioPaypalSelected: 1,
      sku: {
        tree: [],
        list: [],
        price: "11", // 默认价格（单位元）
        stock_num: 227, // 商品总库存
        collection_id: 2261, // 无規格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
        none_sku: false, // 是否无規格商品
        hide_stock: false, // 是否隐藏剩余库存
      },
      show: false,
      goods: {
        transport: {},
        skuList: [{}],
        comboParams: [{}],
      },
      skuGoods: {},
      commentNums:null,//评论数量
      selectedSku: {},
      selectedNum: 1, //商品數量的选择
      imgList: [],
      selectSkuNList: [[]], //套餐中选中的規格数组
      skuImgList: [[]], //規格商品的图片
      cartShow: false, //购物车页面
      comboList: {
        //套餐详情
        title: "", //套餐标题
        oriPrice: "", //套餐原价
        price: "", //套餐价格
        index: 0,
      },
      titleName: "", //标题名字
      comboParams: [],
      selectComboList: [], //选中的套餐的产品列表
      selectSkuImgList: [], //选中的套餐的产品列表--颜色
      selectSkuImgTextList: [[]], //选中的套餐的产品列表--文字
      selSkuNameList: [], //选中的产品的规格列表
      skuIndexList: [[]], //选中的产品的规格列表
      skuId: [],
      pic: [],
      descs: "",
      properties: [],
      shopId: "",
      siteList: [],
      flag: false,
      Lumpuhkan: [],
      sendPop: false,
      show: false,
      radio: "1",
      sendItems: [],
      isactive: true,
      skuImgUrl: [],
      onShows: true,
      items: [],
      skuImgData: [],
      newRadios: "",
      newRadiosData: "",
      paypalList: [
        {
          // icon:'https://images.zzsbx.com/upload/20200925/5fd714bf885640e9b6fa69791b2c0b49.png',
          lable: this.$t("detail.paypaly1"),
          value: 1,
        },
        {
          icon: `https://images.zzsbx.com/upload/20200925/ab6e445de9dd40588f2bdb1366cfab42.png`,
          lable: this.$t("detail.paypaly2"),
          value: 2,
        },
      ],
      prodId:'',
      country:'',
      ensureList:[
        {
          lable:this.$t('ensure.introduce'),
          value:false
        },
        {
          lable:this.$t('ensure.Specifications'),
          value:false
        },
        {
          lable:this.$t('ensure.ensure'),
          value:false
        }
      ]
    };
  },
  computed: {
    count: {
      get() {
        let cartGoods = this.$store.state.goods.shopCardGoods;
        let count = cartGoods.reduce((total, item) => total + item.num, 0);
        return count;
      },
    },
    orderGoods: {
      get() {
        return this.$store.state.goods.orderGoods;
      },
      set(val) {},
    },
    regionData: {
      get() {
        return this.$store.state.user.regionData;
      },
    },
  },
  watch: {
    regionData: {
      handler(newValue, oldValue) {
        //当改变时执行事件
        // console.log('new',newValue)
        // this.getcountry();
        // this.$Fbq.getFbqId("", newValue.shopId); //fbq像素
      },
    },
  },
  destroyed() {},
  mounted(){
    let content,attrContent,ensureContent
    setTimeout(()=>{
      content = $(".content").offset().top-80
      attrContent = $(".attrContent").offset().top-80
      ensureContent = $(".ensureContent").offset().top-80
    },3000)
    let that = this
    window.addEventListener("scroll", function () {
      let scrollTops = document.documentElement.scrollTop || document.body.scrollTop
      
      if(scrollTops<content){
        that.ensureList.forEach((item,index)=>{
          item.value = false
        })
      }else if(content<scrollTops && scrollTops<attrContent){
        // console.log(that.ensureList)
        // that.ensureList[1].value = true
        that.ensureList.forEach((item,index)=>{
          if(index==0){
            item.value = true
          }else{
            item.value = false
          }
        })
      }else if(attrContent<scrollTops && scrollTops<ensureContent){
        // console.log(3)
        that.ensureList.forEach((item,index)=>{
          if(index==1){
            item.value = true
          }else{
            item.value = false
          }
        })
      }else{
        that.ensureList.forEach((item,index)=>{
          if(index==2){
            item.value = true
          }else{
            item.value = false
          }
        })
      }
      })
     
    // if(content>scrollTop){

    // }
  },
  created() {
    let url = location.host.split('/')[0]
    home.region(url).then(res => {
      // let events = JSON.parse(res.googleEvent)
      if(res.googleRop){
        googFb.getId(res.googleRop)
        sessionStorage.setItem('googleRop',res.googleRop)
      }
      if(res.googleEvent){
        sessionStorage.setItem('googleEvent',JSON.stringify(res.googleEvent))
        googFb.addTocar(res.googleRop,res.googleEvent.move)
      }
      sessionStorage.setItem('encode',res.encode)
      let clientWidth = document.documentElement.clientWidth + 250;
      let skuClientWidth = document.documentElement.clientWidth
      this.clientWidth = clientWidth;
      this.process = "?x-oss-process=image/resize,w_" + clientWidth ;
      this.skuProcess = "?x-oss-process=image/resize,w_" + skuClientWidth;
      this.$Fbq.fbqFb(res.fbRop); //fbq像素
      if(res.fbRop.length>0){
        let fbRop = JSON.stringify(res.fbRop)
        sessionStorage.setItem('fbRop',fbRop)
      }
    })
    //xoss 模糊 额外加250
   
    var str = this.$session.get("moneyString");
    this.moneysString = moneys[str];
    window.addEventListener("scroll", function () {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      try {
        var topPin = $("#ljxd").offset().top - 50; // console.log('topPin',topPin)
        if (scrollTop > topPin) {
          $("#ljgm").css("display", "none");
        } else {
          $("#ljgm").css("display", "block");
        }
      } catch (error) {}
    });
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      loadingType: "spinner",
    });

    this.titleName = this.$store.state.designer.titleName;
    // console.log('param1',this.$route.params)
    let param1 = this.$route.params.prodId || {};
    
    let sysUserId, orderSource;
    if(param1.indexOf('_')!=-1){
     var param = {
        prodId:param1.split("_")[1],
        uuid:param1.split("_")[0],
      };
    }else{
      var param = {
        prodId: param1,
      };
    }
    
    // if (param1.type == "tag") {
    //   //商品列表中的详情接口
    //   debugger
      
    //   goods.tagProdInfo(param).then((res) => {
    //     if (res.shopId) {
    //       this.shopId = res.shopId;
    //       this.$store.commit("designer/setShopId", res.shopId);
    //     }
    //     if (res.isPlay == 1) {
    //       //0表示不显示,1 显示
    //       this.getSiteList(res.shopId);
    //     }
    //     if (res.dyRop) {
    //       this.dyRop(res.dyRop);
    //     }
    //     Toast.clear();
    //     this.comboParams = res.comboParams;
    //     this.selectComboList = this.comboParams[this.comboList.index];
    //     let selectComboList = cloneDeep(this.selectComboList);
    //     this.selectComboList = selectComboList;
    //     this.changeSelList();

    //     // console.info('-----全部的数据:',this.selectComboList)

    //     //默认选中的套餐
    //     if (res.comboParams[0].title) {
    //       this.comboList.title = res.comboParams[0].title;
    //     }
    //     if (res.comboParams[0].oriPrice) {
    //       this.comboList.oriPrice = res.comboParams[0].oriPrice;
    //     }
    //     if (res.comboParams[0].price) {
    //       this.comboList.price = res.comboParams[0].price;
    //     }
    //     if (res.comboParams[0].index) {
    //       this.comboList.index = res.comboParams[0].index;
    //     }
    //     this.goods = res;
    //     this.getSkuList();
    //   });
    if(param.uuid){
      goods.newInfo(param).then((res) => {
        // debugger
        let shopID = sessionStorage.getItem('shopId')
        // console.log('shopID',shopID)
        // this.$Fbq.getFbqId("",shopID); //fbq像素
        sessionStorage.setItem('delivery',res.delivery)
        sessionStorage.setItem('REG',res.region)
        let reg = res.region
        goods.regionList(sessionStorage.getItem('shopId')).then(res=>{
          res.forEach((item,index)=>{
            if(reg == item.region){
               sessionStorage.setItem('OptionVal',index)
            }
          })
        })
        if (res.region == "Indonesia") {
          this.isIndonesia = true;
        }
        // this.FbShopId = res.shopId
        this.skuImgData = res;
        let imgs = res.content.replace(/.jpg/g, ".jpg" + this.process);
        this.xossSize = this.process
        if(this.skuImgData.attrContent !=null && this.skuImgData.attrContent.indexOf('.jpg')!=-1){
          this.skuImgData.attrContent.replace(/.jpg/g, ".jpg" + this.xossSize);
        }
        if(this.skuImgData.attrContent !=null && this.skuImgData.attrContent.indexOf('.jpg')!=-1){
          this.skuImgData.ensureContent.replace(/.jpg/g, ".jpg" + this.xossSize);
        }
        this.getSiteList(res.shopId, res.region);
        this.changePay2(res.region);
        if (res.brief == "" || res.brief == " " || res.brief == null) {
          this.brief = false;
        }
        this.comboFareList = JSON.parse(res.combo);
        this.combofareText = this.comboFareList.dynamicItem[0].comboFare;
        this.descs = res.descs;
        this.priceTitle = res.title;
        this.buyShow = res.isReview;
        // console.info(this.buyShow)
        this.prodId = res.prodId;
        this.country = res.country
        // debugger
        this.newRadios = res.region || "台灣";

        // debugger
        this.onNew(res.shopId);
        this.getProdCommList(param.prodId);
        this.items = res.prodTagList;
        
        this.skuImgDatas();
        var arr = res.delivery.split(",");
        arr.forEach((item, index) => {
          var datas;
          if (item.indexOf("宅配") != -1) {
            datas = { id: 1, name: item };
          } else if (item.indexOf("全家") != -1) {
            datas = { id: 3, name: item };
          } else if (item.indexOf("711") != -1) {
            datas = { id: 2, name: item };
          } else if (item.indexOf("OK") != -1) {
            datas = { id: 4, name: item };
          } else if (item.indexOf("萊爾富") != -1) {
            datas = { id: 5, name: item };
          } else {
            datas = { id: 6, name: item };
          }
          // console.info(datas);
          this.sendItems.push(datas);
        });
        this.sendItems.sort(compare("id")); //排序
        if (res.shopId) {
          this.shopId = res.shopId;
          this.$store.commit("designer/setShopId", res.shopId);
        }
        if (res.isPlay == 1) {
          //0表示不显示,1 显示
          // this.getSiteList(res.shopId,res.region);
        }
        if (res.dyRop) {
          this.dyRop(res.dyRop);
        }

        Toast.clear();
        // console.log("====res=====", res);
        this.comboParams = res.comboParams;
        this.selectComboList = this.comboParams[this.comboList.index];
        let selectComboList = cloneDeep(this.selectComboList);
        this.selectComboList = selectComboList;
        this.changeSelList();

        //默认选中的套餐
        if (res.comboParams[0].title) {
          this.comboList.title = res.comboParams[0].title;
        }
        if (res.comboParams[0].oriPrice) {
          this.comboList.oriPrice = res.comboParams[0].oriPrice;
        }
        if (res.comboParams[0].price) {
          this.comboList.price = res.comboParams[0].price;
        }
        if (res.comboParams[0].index) {
          this.comboList.index = res.comboParams[0].index;
        }
        this.goods = res;
        this.goods.content = imgs;
        this.getSkuList();
      })
    } else {
      goods.goodsInfo(param.prodId).then((res) => {
        let shopID = sessionStorage.getItem('shopId')
        sessionStorage.setItem('delivery',res.delivery)
        // console.log('shopID',shopID)
        // this.$Fbq.getFbqId("",shopID); //fbq像素
        sessionStorage.setItem('REG',res.region)
        let reg = res.region
        goods.regionList(sessionStorage.getItem('shopId')).then(res=>{
          res.forEach((item,index)=>{
            if(reg == item.region){
               sessionStorage.setItem('OptionVal',index)
            }
          })
        })
        if (res.region == "Indonesia") {
          this.isIndonesia = true;
        }
        // this.FbShopId = res.shopId
        this.skuImgData = res;
        let imgs = res.content.replace(/.jpg/g, ".jpg" + this.process);
        // console.log('this.skuImgData.attrContent',this.skuImgData.attrContent)
        // debugger
         if(this.skuImgData.attrContent !=null && this.skuImgData.attrContent.indexOf('jpg')!=-1){
          this.skuImgData.attrContent.replace(/.jpg/g, ".jpg" + this.xossSize);
        }
        if(this.skuImgData.attrContent !=null && this.skuImgData.attrContent.indexOf('.jpg')!=-1){
          this.skuImgData.ensureContent.replace(/.jpg/g, ".jpg" + this.xossSize);
        }
        this.getSiteList(res.shopId, res.region);
        this.changePay2(res.region);
        if (res.brief == "" || res.brief == " " || res.brief == null) {
          this.brief = false;
        }
        this.comboFareList = JSON.parse(res.combo);
        this.combofareText = this.comboFareList.dynamicItem[0].comboFare;
        this.descs = res.descs;
        this.priceTitle = res.title;
        this.buyShow = res.isReview;
        // console.info(this.buyShow)
        this.prodId = res.prodId;
        this.country = res.country
        // debugger
        this.newRadios = res.region || "台灣";

        // debugger
        this.onNew(res.shopId);
        this.getProdCommList(param.prodId);
        this.items = res.prodTagList;
        
        this.skuImgDatas();
        var arr = res.delivery.split(",");
        arr.forEach((item, index) => {
          var datas;
          if (item.indexOf("宅配") != -1) {
            datas = { id: 1, name: item };
          } else if (item.indexOf("全家") != -1) {
            datas = { id: 3, name: item };
          } else if (item.indexOf("711") != -1) {
            datas = { id: 2, name: item };
          } else if (item.indexOf("OK") != -1) {
            datas = { id: 4, name: item };
          } else if (item.indexOf("萊爾富") != -1) {
            datas = { id: 5, name: item };
          } else {
            datas = { id: 6, name: item };
          }
          // console.info(datas);
          this.sendItems.push(datas);
        });
        this.sendItems.sort(compare("id")); //排序
        if (res.shopId) {
          this.shopId = res.shopId;
          this.$store.commit("designer/setShopId", res.shopId);
        }
        if (res.isPlay == 1) {
          //0表示不显示,1 显示
          // this.getSiteList(res.shopId,res.region);
        }
        if (res.dyRop) {
          this.dyRop(res.dyRop);
        }

        Toast.clear();
        // console.log("====res=====", res);
        this.comboParams = res.comboParams;
        this.selectComboList = this.comboParams[this.comboList.index];
        let selectComboList = cloneDeep(this.selectComboList);
        this.selectComboList = selectComboList;
        this.changeSelList();

        //默认选中的套餐
        if (res.comboParams[0].title) {
          this.comboList.title = res.comboParams[0].title;
        }
        if (res.comboParams[0].oriPrice) {
          this.comboList.oriPrice = res.comboParams[0].oriPrice;
        }
        if (res.comboParams[0].price) {
          this.comboList.price = res.comboParams[0].price;
        }
        if (res.comboParams[0].index) {
          this.comboList.index = res.comboParams[0].index;
        }
        this.goods = res;
        this.goods.content = imgs;
        this.getSkuList();
      });
    }
    // var nums = 0
    //检测滑动到底部
    window.onscroll = function () {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop; //变量windowHeight是屏幕可用工作区高度
      var windowHeight = window.screen.availHeight; //变量scrollHeight是滚动条的总高度
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight; //滚动条到底部的条件
        // this.scrollHeight = scrollHeight
      // console.info(scrollTop)
      if (scrollTop > 350) {
        $(".scroll").css("position", "static");
      } else {
        $(".scroll").css("position", "absolute");
      }
      // if (scrollTop + windowHeight >= scrollHeight-220) {
      //    if(nums==0){
      //        fbq('track', 'AddToCart');
      //        nums++
      //     }
      // }
    };
  },

  methods: {
    letslazyload(contentp) {
      if(contentp){
        let regexp1 = new RegExp(/(\<img )([^>]*)(src=")([^"]*")([^>]*)(\>)/, 'g');
          contentp = contentp.replace(regexp1, function(match, p1, p2, p3, p4, p5, p6) {
              return p1 + p2 + 'data-src="' + p4 + p5 + p6;
          });
          return contentp;
      }
      },
      // toChinase(val){
      //    switch (val) {
      //     case 1:
      //       return "一";
      //     case 2:
      //       return "二";
      //     case 3:
      //       return "三";
      //     case 4:
      //       return "四";
      //     case 5:
      //       return "五";
      //     case 6:
      //       return "六";
      //     case 7:
      //       return "七";
      //     case 8:
      //       return "八";
      //     case 9:
      //       return "九";
      //     case 10:
      //       return "十";
      //   }
      // },
      goTologistics(){
          this.$router.push({name:"logistics",})
      },
      goTulist(i){
        // zE('webWidget', 'hide');
        if(i==0){
          let content = $(".content").offset().top-30
          $('html,body').animate({'scrollTop':content}); 
          this.scrollTopContent = content
        }else if(i==1){
           let content = $(".attrContent").offset().top-30
           $('html,body').animate({'scrollTop':content});
           this.scrollTopContent = content 
        }else{
           let content = $(".ensureContent").offset().top-30
           $('html,body').animate({'scrollTop':content}); 
           this.scrollTopContent = content
        }
        
        //     window.scrollTo(0, content)
      },
    // Facebook像素
    // getFacebookId(shopId){
    //   goods.faceBook(shopId).then((res) => {
    //       // this.$Fbq.getFbqId("", res.shopId); //fbq像素
    //     this.getFacebookPixel(res,'')
    //   });
    // },
    // getFacebookPixel(id, type = 'index'){
    //   !function(f,b,e,v,n,t,s)
    //   {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    //   n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    //   if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    //   n.queue=[];t=b.createElement(e);t.async=!0;
    //   t.src=v;s=b.getElementsByTagName(e)[0];
    //   s.parentNode.insertBefore(t,s)}(window, document,'script',
    //   'https://connect.facebook.net/en_US/fbevents.js');
    //   id.forEach((item,index)=>{
    //     fbq('init', item);
    //     var testdiv1 = document.getElementById("id1");
    //     testdiv1.innerHTML+= '<img height="1" width="1" style="display:none"  src="https://www.facebook.com/tr?id='.concat(item).concat('&ev=PageView&noscript=1"/>')
    //     var testdiv2 = document.getElementById("id2");
    //     testdiv2.innerHTML+= '<img height="1" width="1" style="display:none"  src="https://www.facebook.com/tr?id='.concat(item).concat('&ev=ViewContent&noscript=1"/>')
    //   })
    // },
    
    // 评论放大图片
    getimgList(pic,item){
      let List = []
      if(pic.indexOf(',')!=-1){
        List = pic.split(',')
        // this.images = List
      }else{
        if(pic){
          List.push(pic)
          this.images = List
        }else{
          //  this.show = false
        }
      }
        ImagePreview({
        images: List,
      startPosition: item,
    });
      // // debugger
      
    },
    onChange(index) {
      this.index = index;
    },
    goToComment(){
      // 去评论页
       this.$router.push({ name: "comment", params: { id: this.prodId} });
    },
    toDetail(id,region) {
      //点击站点去到相对应的页面
      this.$router.push({ name: "siteDetail", params: { id: id ,region: region} });
    },
    getIspay() {
      this.paypalList.forEach((item, index) => {
        this.paypalList[0].lable = this.$t("detail.paypaly1");
        this.paypalList[1].lable = "";
      });
    },
    changeName(){
      this.ensureList.forEach((item,index)=>{
        this.ensureList[0].lable = this.$t("ensure.introduce");
        this.ensureList[1].lable = this.$t("ensure.Specifications");
        this.ensureList[2].lable = this.$t("ensure.ensure");
      })
    },
    // 评论
    addProdCommList() {
      let str = [];
      this.fileList.forEach((item, index) => {
        str.push(item.content);
      });
      if (!this.message) {
        Toast("評論失敗，請輸入内容");
        return false;
      }
      let datas = {
        content: this.message,
        evaluate: Number(this.radios),
        pics: str,
        prodId: Number(this.$route.params.prodId),
      };
      // console.info('添加成功',str)
      goods.addProdComm(JSON.stringify(datas)).then((data) => {
        Toast("評論成功");
        this.onButtom = false;
        this.getProdCommList(this.$route.params.prodId);
        this.message = [];
        this.fileList = [];
        // console.info('添加成功',data)
      });
    },
    getProdCommList(id) {
      goods.getProdComm({ evaluate: -1, prodId: id, current:1,size:10 }).then((data) => {
        this.commentNums = data.total
        this.prodCommList = data.records;
        // this.prodCommList.forEach((item, index) => {
        //   this.prodCommListImg.push(item.pics.split(","));
        // });
        // console.info(this.prodCommListImg)
      });
    },
    onNew(id) {
      this.getIspay();
      // debugger
      if (this.$route.name === "Detail") {
        this.isPage = 1;
        let att = [
          "林先生",
          "林女士",
          "方先生",
          "方女士",
          "黃先生",
          "黃女士",
          "漲先生",
          "漲女士",
          "陳先生",
          "陳女士",
          "鄭先生",
          "鄭女士",
          "龍先生",
          "龍女士",
          "施先生",
          "施女士",
          "李先生",
          "李女士",
          "曹先生",
          "曹女士",
          "廖先生",
        ];
        if (this.newRadios === "台灣") {
          setInterval(() => {
            let index = Math.ceil(Math.random() * 20);
            this.buy = `${att[index]}${index + 30}秒前已購買`;
            this.textShow = !this.textShow;
          }, 2000);
        }

        goods.getArea({ region: this.newRadios }).then((res) => {
          this.newRadiosData = res;
          this.changePay2(res[0].areaName);
          this.getcountry();
          // this.$Fbq.getFbqId('',id); //fbq像素
          this.itemsIsShow = false;
        });
        //       let url = location.host;
        //       home.region(url).then((res) => {
        //       })
      } else {
        // debugger
        goods.getArea({ region: this.newRadios || -1 }).then((res) => {
          // console.log(res)
          this.newRadiosData = res;
          this.regAreaid = res[0].areaId;
          this.changePay2(res[0].areaName);
          this.getcountry(res[0].areaId);
          // this.$Fbq.getFbqId('',id); //fbq像素
        });
        // let url = location.host;
        //       home.region(url).then((res) => {
        //         this.$Fbq.getFbqId('',sessionStorage.getItem('shopId')); //fbq像素
        //       })
        this.isPage = 0;
        this.buyShow = this.buyShow;
        // if(this.area2Data.length<=0){
        //   this.getcountry();
        // }else{
        //   this.getcountry(1);
        // }
      }
    },
    // 
    changePay2(item) {
      if (item == "台灣") {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "tw");
        sessionStorage.setItem("locale", "tw");
      } else if (item == "Malaysia") {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "ma")
          : (this.$i18n.locale = "ma");
        sessionStorage.setItem("locale", "ma");
      } else if (item == "日本") {
        //如果是日本显示日本菜单栏
        this.isButtonCar = true
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "ja")
          : (this.$i18n.locale = "ja");
        sessionStorage.setItem("locale", "ja");
      } else if (item == "ประเทศไทย") {
        this.isButtonCar = true
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tg")
          : (this.$i18n.locale = "tg");
        sessionStorage.setItem("locale", "tg");
      } else if (item == "Singapore") {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "en")
          : (this.$i18n.locale = "en");
        sessionStorage.setItem("locale", "en");
      } else if (item == "香港") {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "hk")
          : (this.$i18n.locale = "hk");
        sessionStorage.setItem("locale", "hk");
      } else if (item == "Pilipinas") {
        this.isButtonCar = true
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "flb")
          : (this.$i18n.locale = "flb");
        sessionStorage.setItem("locale", "flb");
      } else if (item == "Việt Nam") {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "yn")
          : (this.$i18n.locale = "yn");
        sessionStorage.setItem("locale", "yn");
      } else if (item == "Indonesia") {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "is")
          : (this.$i18n.locale = "is");
        sessionStorage.setItem("locale", "is");
      }
      this.changeName()
      this.getIspay();
    },
    // 选择套餐时的方法
    skuImgDatas(indexs) {
      var index = indexs ? indexs : 0;
      this.countList = [];
      // console.info(this.skuImgData.comboParams[index].comboProds[0].prodId)
      var datasImg = this.skuImgData.comboParams[index].comboProds;
      datasImg.forEach((item, index) => {
        // console.info(item.prodCount)
        this.countList.push(item.prodCount);
        var arr = [];
        item.productProps[0].prodPropValues.forEach((items, indexs) => {
          var srcs = -1;
          // console.info(items)
          // debugger
          item.skuList.forEach((itemsp, indexsp) => {
            var strings = itemsp.propertiesId;
            if (strings.indexOf(items.valueId + "") !== -1) {
              srcs = itemsp.pic;
            }
          });
          if (srcs != -1) {
            arr.push(srcs);
          }
        });
        this.skuImgUrl.push(arr);
      });
    },
    onNavBar(id) {
      this.$router.push({ path: "/GoodsCategory", query: { index: id } });
    },
    ...mapMutations("goods", {
      removeShopCardGoods: "removeShopCardGoods",
      refreshOrderGoods: "refreshOrderGoods",
    }),
    getcountry(onSon) {
      // debugger
      // let url = location.host;
      // console.info(this.newRadiosData)
      let res = {};
      if (this.$route.name === "Detail") {
        $(".goods").css("margin-top", "0px");
        res = this.newRadiosData[0];
        let url = location.host;
        // home.region(url).then((res) => {
        //   this.$Fbq.getFbqId("", res.shopId); //fbq像素
        // });
        //  this.getSiteList(this.shopId,res.areaName)
      } else {
        // res=this.regi
        res = this.newRadiosData[0];
        // debugger
      }
      // home.region(url).then(res => {
      // console.log("1111111111111111111111111111",res,'-------', this.$store.state.user.regionData);
      var dz = res.region || res.areaName; //获取国家
      this.areaCode = res.areaCode; //获取code;
      this.area1 = res.id || res.areaId; //获取国家id
      this.pid = this.newRadios; //国家

      // debugger
      if (this.pid == "台灣") {
        this.maxlength = "10";
      } else {
        this.maxlength = "20";
      }
      if (this.pid == "日本" || this.pid == "Singapore") {
        this.onShows = false;
      }
      if (
        this.pid == "Việt Nam" ||
        this.pid == "Pilipinas" ||
        this.pid == "ประเทศไทย" ||
        this.pid == "Indonesia"
      ) {
        this.area4Show = true;
      }
      if (this.pid == "Indonesia") {
        this.area5Show = true;
      }
      if (this.pid == "台灣" || this.pid == "香港") {
        this.postCodeShow = false;
      } else {
        this.postCodeShow = true;
      }
      this.area1Data = [];
      this.area1Data.push({ text: this.$t("Guarantee.country"), value: -1 });
      var arr = {
        text: dz,
        value: this.area1,
      };
      this.area1Data.push(arr);
      // debugger
      if (onSon != 1) {
        // debugger
        this.listByPid(this.area1, 1);
      } else {
        this.listByPid(this.area1, 1);
      }
      // if(res.region !='台灣'){
      //  this.getValue = '3'
      // }
      // if(res.region =='日本'){
      //   this.isShow=false
      // }
      // });
    },
    getDteailName(data, index) {
      if (data == -1) {
        return " ";
      }
      var name;
      if (index === 1) {
        this.area1Data.forEach((item, index) => {
          if (data == item.value) {
            name = item.text;
          }
        });
      } else if (index < 4) {
        var datas = index == 2 ? this.area2Data : this.area3Data;
        datas.forEach((item, index) => {
          if (data == item.value) {
            name = item.text;
          }
        });
      } else if (index == 4) {
        var datas = this.area4Data;
        datas.forEach((item, index) => {
          if (data == item.value) {
            name = item.text;
          }
        });
      } else if (index == 5) {
        var datas = this.area5Data;
        datas.forEach((item, index) => {
          if (data == item.value) {
            name = item.text;
          }
        });
      }

      return name;
    },
    listByPid(pid, index) {
      let param = { pid: pid == undefined ? "1" : pid };
      if (this.getValue == 1 || this.getValue == 6) {
        goods.listByPid(param).then((res) => {
          var json = JSON.parse(
            JSON.stringify(res).replace(/areaId/g, "value")
          );
          var datas = JSON.parse(
            JSON.stringify(json).replace(/areaName/g, "text")
          );
          // console.info("ttttttttttttttttttttt", res, "----", json, datas);
          if (index == 1) {
            this.area2Data = datas;
            this.area2Data.push({
              text: this.$t("Guarantee.region"),
              value: -1,
            });
            this.area2 = -1;
            this.area3Data.push({
              text: this.$t("Guarantee.region_s"),
              value: -1,
            });
            this.area4Data.push({
              text: this.$t("Guarantee.village"),
              value: -1,
            });
            this.area5Data.push({
              text: this.$t("Guarantee.villages"),
              value: -1,
            });
          } else if (index == undefined) {
            //加载第三级
            this.area3 = -1;
            this.area3Data = datas;
            this.area3Data.push({
              text: this.$t("Guarantee.region_s"),
              value: -1,
            });
          } else if (index == 3) {
            //加载第四级
            this.area3Data.forEach((item) => {
              if (item.value == pid && pid != -1) {
                // this.postCode =Number(item.postCode);
                // this.userData.postCode=Number(item.postCode);
              }
            });
            if (pid == -1) {
              this.userData.postCode = "";
            }
            //  console.info(this.postCode)
            this.area4 = -1;
            this.area4Data = datas;
            this.area4Data.push({
              text: this.$t("Guarantee.village"),
              value: -1,
            });
          } else if (index == 4) {
            //加载第5级
            this.area4Data.forEach((item) => {
              if (item.value == pid && pid != -1) {
                // this.postCode =Number(item.postCode);
                // this.userData.postCode=Number(item.postCode);
              }
            });
            if (pid == -1) {
              this.userData.postCode = "";
            }
            //  console.info(this.postCode)
            this.area5 = -1;
            this.area5Data = datas;
            this.area5Data.push({
              text: this.$t("Guarantee.village"),
              value: -1,
            });
          }
        });
      } else if (this.getValue >= 2 && this.getValue < 6) {
        let Datalist = [];
        if (this.getValue === 2) {
          Datalist = roc_711;
        } else if (this.getValue === 3) {
          Datalist = roc_qj;
        } else if (this.getValue === 4) {
          Datalist = roc_tw;
        } else {
          Datalist = roc_tw_new;
        }
        this.area2Data = [];
        Datalist.area_2[this.area1].forEach((item, index) => {
          var data = {
            text: item,
            value: index,
          };
          this.area2Data.push(data);
          this.area2 = pid > 0 ? pid : 0;
        });
        this.area3Data = [];
        Datalist.area_3[this.area1][this.area2].forEach((item, index) => {
          var data = {
            text: item.Address,
            value: index,
          };
          this.area3Data.push(data);
          this.area3 = 0;
        });

        var datas = Datalist.area_3;
        var arr =
          this.getDteailName(this.area3, 3) +
          ",店名:" +
          datas[this.area1][this.area2][this.area3].POIName +
          ",店號:" +
          datas[this.area1][this.area2][this.area3].POIID +
          ",电话:" +
          datas[this.area1][this.area2][this.area3].Telno;
        var newArr = arr.replace(/\s*/g, "");
        this.userData.detailed = newArr;
      }
    },
    getSiteList(shopId, region) {
      //获取站点列表
      goods.topSiteList({ shopId: shopId, region: region }).then((res) => {
        this.siteList = res;
      });
    },
    changeSelList() {
      //初始化辅助数组
      if (this.selectComboList.comboProds) {
        this.selectComboList.comboProds.forEach((itemc, indexc) => {
          this.selectSkuImgList.push(0);
          this.selectSkuNList[indexc] = new Array();
          this.skuIndexList[indexc] = new Array();
          itemc.productProps.forEach((item_p, index_p) => {
            this.selectSkuNList[indexc].push(0);
            this.skuIndexList[indexc][index_p] =
              item_p.prodPropValues[0].valueId;
          });
        });
      }
    },
    // 选择SKU
    toSelectSkuName(index, indexx, indexp, valueId, item, itemp, itemm) {
      if(itemm.imageUrl){
        this.skuImgData.pic = itemm.imageUrl
      }

      //选中的sku的名字
      // console.log(index, indexx, indexp, valueId, item, itemp, itemm);
      this.selectSkuNList[index][indexp] = indexx;
      let arr = cloneDeep(this.selectSkuNList);
      this.selectSkuNList = arr;
      this.skuIndexList[index][indexp] = valueId;
      this.getSkuList(arr);
      let propertiesStr = this.skuIndexList[index].join(",");
      item.skuList.forEach((ele, i) => {
        if (ele.propertiesId == propertiesStr) {
          // console.log("ele.status==0", ele);
          if (ele.status == 0) {
            Toast(this.$t("contactUs.shortSale"));
            this.flag = true;
            if (this.Lumpuhkan.length <= 0) {
              //如果数组没有， 那么先保存第一次点击的值
              var arr = { index: index, indexp: [indexp] };
              this.Lumpuhkan.push(arr);
            } else {
              //如果有， 就判断下当前的商品 颜色和尺码
              var hakim = -1;
              this.Lumpuhkan.forEach((key, val) => {
                if (key.index == index && key.indexp.indexOf(indexp) == -1) {
                  //判断这个数组对象对应商品是否有颜色和尺码没有就添加进去
                  this.Lumpuhkan[val].indexp.push(indexp); //保存操作的选项
                  // console.info('没有规格',key,val)
                }
                if (key.index == index) {
                  hakim = index;
                }
              });
              if (hakim == -1) {
                //如果没有， 那么就直接保存当前的操作
                var arr = { index: index, indexp: [indexp] };
                this.Lumpuhkan.push(arr);
              }
            }
          }
          if (ele.status == 1) {
            this.flag = false;
            this.Lumpuhkan.forEach((key, val) => {
              if (key.index == index) {
                //判断这个数组对象对应商品是否有颜色和尺码 有就将对应的按钮标识删除
                //  console.info('有这个',key,val)
                this.Lumpuhkan.splice(this.Lumpuhkan.indexOf(val), 1);
              }
            });
          }
        }
      });
      if (this.Lumpuhkan.length > 0) {
        this.flag = true;
      }
    },
    toSelectSkuImg(index, index_img, indexp, valueId) {
      //选中的sku的图片
      this.selectSkuImgList[index] = index_img;
      let selectSkuImgList = cloneDeep(this.selectSkuImgList);
      this.selectSkuImgList = selectSkuImgList;
      this.skuIndexList[index][indexp] = valueId;
      this.getSkuList();
    },
    getSkuList() {
      let selectCombo = this.selectComboList;
      var selectList = [];
      selectList = this.selectComboList.comboProds;
      this.skuIndexList.forEach((item, index) => {
        let skuIndex = "";
        item.forEach((item_m, index_m) => {
          skuIndex = skuIndex + item_m + ",";
        });
        skuIndex =
          skuIndex.substring(skuIndex.length - 1) == ","
            ? skuIndex.substring(0, skuIndex.length - 1)
            : skuIndex;
        selectList[index].skuList.forEach((item_s, index_s) => {
          if (skuIndex == item_s.propertiesId) {
            this.skuId[index] = item_s.skuId;
            this.pic[index] = item_s.pic;
            if (item_s.properties.indexOf(";") != -1) {
              this.properties[index] =
                item_s.properties.split(";")[0].split(":")[1] +
                "   " +
                item_s.properties.split(";")[1].split(":")[1];
            } else {
              this.properties[index] = item_s.properties.split(":")[1];
            }
          }
        });
      });
    },
    // 选择套餐
    toSelectCombo(indexc, title, price, oriPrice) {
      this.skuImgUrl = [];
      this.skuImgDatas(indexc);
      //选择套餐
      // let arr = Array.from(this.comboFareList)
      this.combofareText = this.comboFareList.dynamicItem[indexc].comboFare;
      this.Lumpuhkan = []; //清空商品选择
      this.comboList.index = indexc;
      this.comboList.title = title;
      this.comboList.price = price;
      this.comboList.oriPrice = oriPrice;
      this.selectComboList = this.comboParams[indexc];
      let arr = cloneDeep(this.selectComboList);
      this.selectComboList = arr;
      //选中的套餐的产品列表
      (this.properties = []),
        (this.skuId = []),
        (this.pic = []),
        (this.selectSkuNList = [[]]);
      this.selectSkuImgList = [];
      this.skuIndexList = [[]];
      this.changeSelList();
      this.getSkuList();
      // let comboList = cloneDeep(this.comboList)
      // this.comboList= comboList
    },
    addCarts() {
      // 报表的意向购买次数
      let param = {
          'prodId':this.prodId,
          'shopId':this.shopId,
          'urlSource':location.href,
          'isPage':this.isPage,
          'amount':0,
          'intentions':1
        }
      goods.record(JSON.stringify(param)).then(res => {
        
      })
      this.iscarfalse =  true
      this.ispurchase =  false
      if(this.nums == 0){
        this.nums++
        fbq('track', 'Lead');
      }
      //立即購買
      this.cartShow = true;
    },
    home() {
      this.$router.replace("/");
    },
    ...mapMutations("goods", {
      addShopCardGoods: "addShopCardGoods",
      refreshOrderGoods: "refreshOrderGoods",
    }),
    formatPrice(price) {
      // return "NT$" + price;
      return +price;
    },
    onClickCart() {
      this.$router.push("/cart");
    },
    getSkuPrice(skuId) {
      for (let i = 0; i < this.goods.skuList.length; i++) {
        if (this.goods.skuList[i].skuId === skuId) {
          return this.goods.skuList[i].price;
        }
      }
    },
    addCart() {
      if (this.selectedSku.id == undefined || this.selectedSku.id == null) {
        // Toast('請選擇一种規格');
        this.show = true;
        return;
      }
      let buyGoods = cloneDeep(this.goods);
      buyGoods.selectedSkuId = this.selectedSku.id;
      buyGoods.selectedSkuName = this.selectedSku.name;
      buyGoods.selectedSkuPrice = this.getSkuPrice(this.selectedSku.id);
      buyGoods["num"] = this.selectedNum;
      this.addShopCardGoods(buyGoods);
      Toast(this.$t("tips.cart_success"));
    },
    alertSKU(){
      let goRop = sessionStorage.getItem('googleRop')
      let goEvent = sessionStorage.getItem('googleEvent')
      if(goEvent){
        goEvent = JSON.parse(goEvent).qzkh
        googFb.addTocar(goRop,goEvent)
      }
      //google 潜在客户 
      let param = {
          'prodId':this.prodId,
          'shopId':this.shopId,
          'urlSource':location.href,
          'isPage':this.isPage,
          'amount':0,
          'intentions':1
        }
      goods.record(JSON.stringify(param)).then(res => {
        
      })
      this.ispurchase =  true
      this.iscarfalse =  false
      if(this.numss == 0){
        this.numss++
        fbq('track', 'Lead');
      }
      this.cartShow = true;
    },
    buyNow() {
      // 选择地址前
      fbq('track', 'AddToCart');
      let selectSku = []
      let buyGoodsList= cloneDeep(this.selectComboList.comboProds);
      let arrayProdName = []
      buyGoodsList.forEach((item, index) => {
        arrayProdName.push(item.prodName)
      })
      console.log('arrayProdName',arrayProdName)
      this.pic.forEach((item,index)=>{
        let obj ={
                pic:null,
                prodCount:null,
                selectedSkuName:null,
                ProdName:null
              }
          obj.pic = this.pic[index]
          obj.prodCount = this.countList[index]
          obj.selectedSkuName = this.properties[index]
          obj.ProdName = arrayProdName[index]
          selectSku.push(obj)
      })
      sessionStorage.setItem('combofareText',this.combofareText)
      sessionStorage.setItem('comboListP',this.comboList.price)
      sessionStorage.setItem('selectSku',JSON.stringify(selectSku))
      
      // this.$store.state.designer.List = this.selectComboList.comboProds
      // this.$store.state.designer.imgList = this.properties
      // this.$store.state.designer.numList = this.countList
      // this.$store.state.designer.pic = this.pic
      // this.selectComboList.comboProds
      let buyGoods = cloneDeep(this.selectComboList.comboProds);
      buyGoods.forEach((item, index) => {
        item.selectedSkuId = this.skuId[index];
        item.skuList.forEach((item_sku, index_sku) => {
          if (item_sku.skuId == this.skuId[index]) {
            item.selectedSkuPrice = item_sku.price;
            item.selectedSkuName = item_sku.properties;
            this.ProdListName.push(item_sku.prodName);
          }
        });
        item.allPrice = this.selectComboList.price;
        item.selectedProdName = this.selectComboList.title;
        item.selectedProdId = this.goods.prodId;
        item["num"] = this.selectedNum;
      });
      this.refreshOrderGoods(buyGoods);
      let goodsData = this.$store.state.goods.orderGoods;
      let orderItems = []; //订单的産品列表
      let arrs = this.countList;
      let packageName = this.comboList.title;
      orderItems.push({
        packageName: packageName,
        prod: this.goods.prodId,
        urlSource: window.location.href,
      });
      goodsData.forEach(function (item, index) {
        orderItems.push({
          country:item.country,
          prodId: item.prodId,
          shopId: item.shopId,
          prodCount: arrs[index],
          skuId: item.selectedSkuId,
        });
      });
      // console.log(orderItems)
      sessionStorage.setItem("prodList", JSON.stringify(orderItems));
      // this.$router.push("/orderStep4");
    },
    addToCar(){
      sessionStorage.setItem('carDelivery',this.skuImgData.delivery)
      // 加入购物车
      if(sessionStorage.getItem('googleRop')){
        googFb.addTocar(sessionStorage.getItem('googleRop'),JSON.parse(sessionStorage.getItem('googleEvent')).addToCar)
      }
      if(this.num == 0){
         this.num++
         fbq('track', 'AddToCart');
        let param = {
          'prodId':this.prodId,
          'shopId':this.shopId,
          'urlSource':location.href,
          'isPage':this.isPage,
          'amount':1,
          'intentions':0
        }
        goods.record(JSON.stringify(param)).then(res => {
          this.fbnum++
        })
       }
      Toast(this.$t("tips.cart_success"));
      setTimeout(()=>{
        this.cartShow = false
      },1000)
      let buyGoods = cloneDeep(this.selectComboList.comboProds);
      buyGoods.forEach((item, index) => {
        item.selectedSkuId = this.skuId[index];
        item.skuList.forEach((item_sku, index_sku) => {
          if (item_sku.skuId == this.skuId[index]) {
            item.selectedSkuPrice = item_sku.price;
            item.selectedSkuName = item_sku.properties;
            this.ProdListName.push(item_sku.prodName);
          }
        });
        item.allPrice = this.selectComboList.price;
        item.selectedProdName = this.selectComboList.title;
        item.selectedProdId = this.goods.prodId;
        item["num"] = this.selectedNum;
      });
      this.refreshOrderGoods(buyGoods);
      let goodsData = this.$store.state.goods.orderGoods;
      let orderItems = []; //订单的産品列表
      let arrs = this.countList;
      let items = []
      let packageName = this.comboList.title;
      orderItems.push({
        packageName: packageName,
        prod: this.goods.prodId,
        item:items,
        PackagePrice:this.comboList.price,
        combofareText:Number(this.combofareText),
        urlSource: window.location.href,
      });
      goodsData.forEach(function (item, index) {
        items.push({
          prodId: item.prodId,
          shopId: item.shopId,
          prodCount: arrs[index],
          skuId: item.selectedSkuId,
          // allPrice:item.allPrice,
          selectedSkuName:item.selectedSkuName,
          prodName:item.prodName
        });
      });
      this.pic.forEach((item,index)=>{
        items[index].pic = item
      })
      console.log(orderItems)
      if(sessionStorage.getItem("orderItems")){
        JSON.parse(sessionStorage.getItem('orderItems')).forEach((item,index)=>{
          orderItems.push(item)
        })
        sessionStorage.setItem("orderItems",JSON.stringify(orderItems))
      }else {
        sessionStorage.setItem("orderItems",JSON.stringify(orderItems))
      }
    },
    dyRop(dyRop) {
      //抖音的像素
      sessionStorage.setItem("dyRop", dyRop);
      var ta = document.createElement("script");
      ta.type = "text/javascript";
      ta.async = true;
      ta.src = "https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid=" + dyRop;
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(ta, s);
    },
    changePay(item) {
      this.show = false;
      if (item == 1) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "tw");
      } else if (item == 2) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "zh");
      } else if (item == 3) {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "en");
      } else {
        let locale = this.$i18n.locale;
        locale === "null"
          ? (this.$i18n.locale = "tw")
          : (this.$i18n.locale = "ma");
      }
    },
  },
};
</script>

<style lang="scss" scoped='scoped'>
.goods{
  background: #fff;
}
#ljgm {
  height: 60px;
}
.buy-body .van-radio-group {
  display: flex;
}
.switchs {
  position: relative;
  left: 65%;
}
.switchs span {
  position: relative;
  top: -5px;
}
.buy-body .van-button--large {
  height: 40;
  line-height: 40px;
}
.buy-body .van-radio {
  margin: 10px 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.buy-body .img-flex {
  margin: 0 20px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  padding-bottom: 20px;
}
.prod-comm {
  overflow: hidden;
  padding-bottom: 20px;
  border-bottom: 1px solid #f3eeee;
}
.prod-comm .van-card__thumb {
  width: 35px;
  height: 35px;
  margin-top: -2px;
}
.prod-comm .van-card {
  height: 50px;
  background: #fff;
}
.scroll-top {
  position: relative;
  top: -50px;
  position: sticky;
  top: 20px;
}
.scroll {
  // position: fixed;
  // top: 10px;
  position: absolute;
  top: -50;
  margin-left: 20px;
  width: 40%;
  line-height: 20px;
  background: #fff;
  border-radius: 20px;
  text-align: center;
  animation: 3s wordsLoop linear infinite normal;
  box-shadow: 0px 0px 4px #888888;
  font-size: 0.15rem;
}
@keyframes wordsLoop {
  0% {
    // transform: translateX(200px);
    // -webkit-transform: translateX(200px);
    opacity: 1;
  }
  100% {
    // transform: translateX(-100%);
    // -webkit-transform: translateX(-100%);
    opacity: 0;
  }
}

@-webkit-keyframes wordsLoop {
  0% {
    // transform: translateX(200px);
    // -webkit-transform: translateX(200px);
    opacity: 1;
  }
  100% {
    // transform: translateX(-100%);
    // -webkit-transform: translateX(-100%);
    opacity: 0.2;
  }
}

.row-text-color {
  border-top: 1px solid #c6c6c6;
}
.img-border-row {
  display: flex;
  flex-wrap: wrap;
}
.img-border {
  border-radius: 5px;
  border: solid 1px #c6c6c6;
  width: 22%;
  // flex: 1;
  text-align: center;
  // padding:3px 0;
  // overflow: hidden;
  margin: 5px 5px;
}
.img-on-border {
  border: solid 2px #f78491;
}
.notice {
  margin: 15px;
  // border: solid 1px #ccc;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  .notice-dt {
    // color: black !important;
    padding: 15px;
    font-weight: bold;
  }
  .notice-dd {
    padding: 0 15px;
    // color: rgba(0, 58, 117, 0.7) !important;
  }
  div,
  dl  {
    padding: 15px;
  }
}
.notice_span {
  height: 20px;
  font-size: 16px;
  background: rgba(0, 0, 0, 0.2);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  display: flex;
  align-items: center;
}

.form-button {
  padding: 0 20px;
  margin: 20px 0;
}
.form-text-color {
  color: red;
}
.van-dropdown-menu__bar {
  box-shadow: 0 0px 0px rgba(100, 101, 102, 0.08);
  border: solid 1px #dddddd;
  margin: 10px 0;
}
.form-radio {
  margin: 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .van-col--6 {
    width: auto;
    padding: 0 5px;
  }
  .form-radio-type {
    // width:30%;
    min-width: 30%;
    width: auto;
    border: solid 1px #8c8c8c;
    text-align: center;
    line-height: 21px;
    margin: 0 5px;
    margin-bottom: 10px;
    border-radius: 3px;
    padding: 5px 10px;
  }
  .form-radio-selected {
    border: solid 1px #ee0a24;
    color: #ee0a24;
  }
  .form-paypal-selected {
    border: solid 1px #ee0a24;
    color: #ee0a24;
  }
}
.form-body {
  padding: 0 20px;
  .form-title {
    // font-family: 'Medium';
    font-size: 16px;
    padding: 0 0 10px 0;
  }
  .field {
    border: 1px #ddd solid;
    border-radius: 0.12rem;
    margin: 10px 0;
  }
}
.costs {
  padding: 2% 0%;
  font-size: 14px;
  color: #8c8c8c;
}
.costs-red {
  font-size: 18px;
  font-weight: bold;
  color: EF0000;
  margin-top: 5px;
}
.title-top {
  // height: 11%;
  // font-family: 'Bold';
  width: 90%;
  padding: 2% 5%;
  border-top: 0.2rem solid #f5f5f5;
  font-size: 22px;
  font-weight: 600;
  margin-top: 10px;
}
.selected-table {
  width: 90%;
  margin: auto;
  border: 1px solid #f5f5f5;
  text-align: center;
  margin-bottom: 20px;
  .back-table {
    background: #e7e7e7;
  }
  .selected-head {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 30px;
    // .selected-left {
    // border-right: 1px solid #f5f5f5;
    // }
    // .table-right {
    // line-height: 140px;
    // }
  }
  .table-borders {
    border: solid 1px #f5f5f5;
    padding: 10px;
    padding-left: 0px;
  }
}

.huise {
  background: black;
}
// .goods .header_img, .goods .my-swipe{
//   height: auto !important;
// }
.goods {
  padding-bottom: 50px;
  margin-top: 40px;
  // .my-swipe {
  // height: 15rem;
  // height: auto !important;
  // height: auto;
  // }
  .header_img {
    width: 100%;
    // height: auto;
  }
  // .van-swipe__track{
  // height: 53%;
  // height: 56%;
  // }
  .van-image__img {
    // height: auto;
  }
  &-title {
    font-size: 16px;
  }
  &-brief {
    font-size: 13px;
    // color: #d85757;
  }
  &-price {
    color: #f44;
    font-size: 18px;
    .source {
      font-size: 10px;
      color: #868788;
      text-decoration: line-through;
      padding-left: 10px;
    }
  }
  .sku_line_item {
    display: flex;
    color: #7c7d7d;
    font-size: 12px;
    justify-content: space-between;
  }
  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }
  &-cell-group {
    margin: 15px 0;
    .van-cell__value {
      color: #999;
    }
  }
  &-tag {
    margin-left: 5px;
  }
}
.border {
  border-top: 0.2rem solid #f8f8f8;
  border-bottom: 0.2rem solid #f8f8f8;
  color: #7c7d7d;
}
.color {
  color: #7c7d7d;
}
.sheet {
  height: 90%;
  // overflow-y: hidden;
  // z-index: 2004;
  // padding-bottom: 2rem;
  .title {
    // height: 11%;
    width: 90%;
    padding: 2% 5%;
    border-bottom: 0.2rem solid #f5f5f5;
    span {
      font-size: 0.25rem;
      font-weight: 550;
    }
    // .name{
    //   padding-left: 0.2rem;
    // }
    .money {
      color: #ca2e2e;
    }
    .orign {
      font-size: 0.5rem;
      color: #868788;
      text-decoration: line-through;
      padding-left: 0.5rem;
    }
  }
  .cont {
    height: auto;
    // overflow-y: scroll;
    padding-bottom: 25%;
    // overflow-x: scroll;
    // overflow-y: hidden;
  }
}

.combo {
  padding-bottom: 0%;
  .goodSheet {
    width: 90%;
    margin: 2% 5%;
    .van-col {
      // margin: 0 2%;
      line-height: 1.1rem;
    }
    .van-tag {
      margin: 0.2rem;
    }
  }
  .grid {
    width: 90%;
    margin-left: 5%;
    // margin-top: 0.5rem;
    .grid_item {
      .van_img {
        width: 1.8rem;
        height: 1.8rem;
        padding: 0.2rem;
        border: 0.05rem solid #e4e4e4;
        margin: 0.2rem;
      }
    }
    .select {
      .van_img {
        width: 1.8rem;
        height: 1.8rem;
        padding: 0.2rem;
        border: 0.05rem solid #e4e4e4;
        margin: 0.2rem;
        border: 0.05rem solid #ee0a24;
      }
    }
  }
}
.comboSelect {
  width: 90%;
  padding: 2% 3% 4% 3%;
  margin: 1%;
  border-bottom: 0.01rem solid #e2dfdf;
  .name {
    // line-height: 1rem;
    // margin-top: 10px;
    // margin-bottom: 10px;
  }
  .list {
    .van-tag {
      margin: 0.1rem;
      // height: 1rem;
      padding: 7px;
      // height: 24px;
    }
    .select {
      color: #ca2e2e;
    }
  }
}
.skuName {
  font-size: 16px;
  font-weight: 550;
  color: black;
}

.tag {
  padding: 3px 10px;
  margin: 0.08rem;
  height: 25px;
  border-radius: 3px;
}
.nav_title {
  .van-nav-bar__left {
    .van-icon {
      color: #6f6f73;
    }
    .van-nav-bar__text {
      color: #6f6f73;
    }
  }
}
.content{
  padding-bottom: 20px;
}
.content p image {
  height: auto;
}
.sites {
  margin: 30px 0;
  text-align: center;
  padding: 0 30px;
  font-size: 12px;
  // font-family: 'Medium';
  display: block;
  // font-family: 'Bold';
}
.sites span {
  padding: 5px 0;
}
.active {
  // height: 46px;
  // right:-16px
  margin: 0 -16px 2px 0;
}
.goods-price {
  color: black;
  font-size: 25px;
  padding: 15px 0 0 20px;
}
.goods-brief {
  // font-family: Bold;
  // border-top: 1px solid #ccc;
  padding: 10px;
}
.goods-brief span {
  color: white;
  margin-right: 7px;
  padding: 3px 5px;
  background: #fc2961;
  border-radius: 3px;
}
.goods-brief p {
  display: initial;
  font-size: 14px;
  // margin-left: 7px;
  color: #ea3323 ;
}
.goods-methods {
  // font-family: Medium;
  // margin-top: 15px;
  // padding: 15px 0;
  // border-top: 1px solid #ccc;
}
// .goods-methods div span:nth-child(1) {
//   background: #ea3323  !important;
// }
.goods-methods div span {
  background: coral ;
  padding: 5px;
}
.goods-methods span {
  background: red;
  border-radius: 3px;
  margin: 5px 3px;
  color: white;
  padding: 2px;
}
.center {
  // padding: 0 15px;
}
// .Swiper{
//   .c-swipe {
//     .c-swipe-wrapper{
// height: auto !important;
//     }
//   }
// }
.c-swipe-pagination-item {
  background-color: #ebedf0 !important;
  // width: 5px!important;
}
.c-swipe-pagination-item.active {
  background-color: white !important;
  width: 15px !important;
  // z-index: 9999;
}
.c-swipe {
  height: max-content;
  // height: 46%;
}
.fontMoney {
//   background-image: url(~@/assets/titleBage.png);
  background-position: center;
  background-position: -230px 0px;
  width: 100%;
  background-repeat: no-repeat;
  margin-top: -2px;
  height:60px;
}
.fontMoney p {
  display: flex;
  align-items: center;
  // font-family: title;
  // font-weight: bold;
  // letter-spacing: 1px;
  font-size: 28px;
//   color: rgba(255, 255, 255, 1);
  color: #ea3323 ;
  padding: 19px 10px 5px;
}
.van-tag--danger.van-tag--plain {
  color: #ea3323 !important;
}
.PackagePrice {
  // font-family: Bold;
  padding: 20px;
  font-size: 24px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 7px solid #e7e7e7;
}
.PackagePrice span:nth-child(2) {
  color: #fc2a62;
}
.van-row--justify-space-around {
  justify-content: flex-start;
}
.van-cell {
  padding: 5px 8px;
}
.form-radio .form-paypal-selected {
  border: solid 1px #fc2a62;
  color: #fc2a62;
}
.form-radio .form-radio-selected {
  border: solid 1px #fc2a62;
  color: #fc2a62;
}
.ProductDescription {
  text-align: center;
  // font-family: 'Bold';
  color: #fd2e64;
  padding: 0px 50px;
  line-height: 50px;
  font-size: 17px;
}
// @media screen and (min-width: 750px) {
//   .fontMoney {
//     background-image: url(~@/assets/titleBage.png);
//     background-position: center;
//     background-position: 0px;
//     width: 100%;
//     background-repeat: no-repeat;
//   }
// }
// .form-radio-type:nth-child(2) img{
// width: 34px;
// }
.van-card__price-currency {
  font-size: 16px;
}
.van-card__price {
  color: #ee0a24 !important;
}
.Vcode {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Vcode div:nth-child(1) {
  width: 40%;
  margin: 0 10px 0 0;
  min-width: 50%;
  width: auto;
}
.Vcode button {
  width: 50%;
}
.van-goods-action-button--danger { 
  background: #fc2a62 !important;
}
.c-swipe-pagination-bar{
  z-index: 2;
}
.commentTitle{
  text-align:center;
  padding: 15px 0px;
  border-bottom: 0.5px solid #f3eeee;
}
.commentTitle div:nth-child(2) span{
  color: #ee4d2d;
}
.van-image-preview__image{
  display: flex;
}
.prodName{
    padding:8px;
    height:54px;
    background:#F4F4F4
}
.prodName p{
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
}
.businessReply p{
    color: #8b572a;
}
.margin_10{
    margin:10px
}
.businessReply{
    padding: 10px;
    background-color: rgba(0,0,0,.04);
}
.van-button::before{
  left: 0 !important;
  top: -50px !important;
  z-index: 9999;
  content: none;
  position: absolute !important;
}
.stickyDiv{
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    margin: 5px 0;
    display: flex;
    justify-content: center;
    align-items: center; 
    font-size: 0.28rem;
    text-align: center;
    padding: 10px 0;
    background: white;
    max-width: 750px;
    margin: 0 auto;
}
.stickyDiv div{
    width:32%;
    border-right:1px solid #ccc
}
.stickyDiv div:nth-last-child(1){
    border:none
}
.goods-action{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 0;width:100%;background: white;
    width: 100%;
    max-width: 750px;
}
.goods-action-button{
    display: flex;width:33%;padding:0.05rem
}
.goods-action-button-item{
    display: table;display: table;text-align: center;width:50%
}
.goods-action-tocar{
    width:33%;font-size:0.29rem;display: flex;align-items: center;justify-content: center;height: 1rem;background:#ffeded;color:#ea3323
}
.goods-action-ljgm{
    width:33%;font-size:0.29rem;display: flex;align-items: center;justify-content: center;height: 1rem;background:#ea3323;color:white
}
.van-action-sheet{
    max-height: initial;
}
.selectCombo{
  width: 96%;
  display: flex;
  justify-content: center;
  margin: 0.2rem 0;
  border-radius: 3px;
}
.shopTitle{
  padding: 0 0.2rem;
}
.shopMoney{
  padding: 0.15rem 0;
}
.shopMoney span{
  color: #ea3323;
}
.zdyButton{
  width:6rem;
  background:#ea3323;
  color:white;
  border-radius: 5px;
}
.van-action-sheet__content{
  overflow-x: hidden;
}
.redActive{
  color: red;
}
.JA_goods-action-tocar{
  width:33%;
  font-size:0.20rem;
  display:flex;
  align-items:center;
  justify-content:center;
  height:1rem;
  background:#ffeded;
  color:#ea3323
}
.JA_goods-action-ljgm{
  width:33%;
  font-size:0.20rem;
  display:flex;
  align-items:center;
  justify-content:center;
  height:1rem;
  background:#ea3323;
  color:white
}
.JAflex{
  display: flex;
  justify-content: center;
  align-items: center;
  padding:0 5px;
}
.JAflex p{
  font-size: 0.2rem;
  padding: 0 3px;
}
.JA_goods-action_item{
  width: 33%;
}
.stickyActive{
  color: red;
}













@media screen and (max-width: 768px) {
.stickyDiv{
  font-size: 0.28rem;
  
}
.goods-action-button-item p{
  font-size: 0.18rem;
}
}
@media screen and (min-width:768px) and (max-width:970px){
  .stickyDiv{
  font-size: 0.15rem;
} 
.goods-action-tocar{
   height: 0.5rem;
   font-size:0.18rem;
}
.goods-action-ljgm{
    height: 0.5rem;
    font-size:0.18rem;
}
.selectCombo{
  margin: 0.03rem 0;
}
.zdyButton{
  width: 5rem;
}
.sheet {
  .title {
    span {
      font-size: 0.19rem;
    }
  }
}
}
@media screen and (min-width: 970px) {
.goods-action-tocar{
   height: 0.5rem;
   font-size:0.18rem;
}
.goods-action-ljgm{
    height: 0.5rem;
    font-size:0.18rem;
}
.goods-action-button{
  padding:0.04rem
}
.stickyDiv{
  font-size: 0.1rem;
}
.shopTitle{
  padding: 0 0.18rem;
}
.shopMoney span{
  font-size: 0.20rem
}
.zdyButton{
  width: 3rem;
}
.sheet {
  .title {
    span {
      font-size: 0.15rem;
    }
  }
}
.tag{
  margin: 0.04rem;
}
.JAflex p{
  font-size: 0.1rem;
}
.JA_goods-action-tocar{
  height: 0.5rem;
  font-size: 0.1rem;
}
.JA_goods-action-ljgm{
  height: 0.5rem;
  font-size: 0.1rem;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/index/detail/Detail4.vue